import {PermissionModel} from '../index';

export class PermissionGroupModel {
	title: string;
	permissions: PermissionModel[];
}
